import React from "react";
import { Row, Col, Card, Table } from "react-bootstrap";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";
import { CargaMasiva } from "models/ECF/CargaMasiva";

/**
 * Paso 4: Resumen del resultado del guardado.
 * Props:
 *   entidad    - value de la entidad procesada
 *   resultado  - CargaMasivaResultadoDTO { TotalFilas, FilasExitosas, FilasConError, Resultados[] }
 *   onNuevaCarga() - callback para reiniciar el wizard
 */
const ResultadoCarga = ({ entidad, resultado, onNuevaCarga }) => {
  const config = CargaMasiva.getConfigEntidad(entidad);
  const { TotalFilas, FilasExitosas, FilasConError, Resultados } = resultado || {};
  const errores = (Resultados || []).filter((r) => !r.Exitoso);

  return (
    <div>
      {/* Acciones */}
      <div className="d-flex justify-content-end gap-2 mb-3">
        <AnimatedIconButton
          onClick={onNuevaCarga}
          iconName="reload"
          message="Nueva Carga"
          size="38px"
          height="22px"
          width="22px"
        />
      </div>

      {/* Cards de métricas */}
      <Row className="mb-4">
        <Col md={4} className="mb-3">
          <Card className="text-center border">
            <Card.Body>
              <div style={{ fontSize: "2rem", fontWeight: 700 }}>{TotalFilas || 0}</div>
              <div className="text-muted" style={{ fontSize: "0.9rem" }}>
                Total procesadas
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card className="text-center border border-success">
            <Card.Body>
              <div style={{ fontSize: "2rem", fontWeight: 700, color: "#198754" }}>
                {FilasExitosas || 0}
              </div>
              <div className="text-muted" style={{ fontSize: "0.9rem" }}>
                Grabadas exitosamente
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card
            className={`text-center border ${FilasConError > 0 ? "border-danger" : "border-success"}`}
          >
            <Card.Body>
              <div
                style={{
                  fontSize: "2rem",
                  fontWeight: 700,
                  color: FilasConError > 0 ? "#dc3545" : "#198754",
                }}
              >
                {FilasConError || 0}
              </div>
              <div className="text-muted" style={{ fontSize: "0.9rem" }}>
                Con errores
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Detalle de errores */}
      {errores.length > 0 && (
        <div className="mb-4">
          <h6 className="text-danger mb-2">
            <i className="fas fa-exclamation-triangle me-2" />
            Filas con errores
          </h6>
          <div style={{ maxHeight: "30vh", overflowY: "auto" }}>
            <Table bordered size="sm" style={{ fontSize: "0.85rem" }}>
              <thead>
                <tr>
                  <th style={{ width: 80 }}>Fila</th>
                  <th>Motivo del error</th>
                </tr>
              </thead>
              <tbody>
                {errores.map((r) => (
                  <tr key={r.Fila}>
                    <td>{r.Fila}</td>
                    <td className="text-danger">{r.Mensaje}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      )}

      {/* Mensaje de éxito total */}
      {FilasConError === 0 && TotalFilas > 0 && (
        <div className="alert alert-success">
          <i className="fas fa-check-circle me-2" />
          Todas las filas fueron grabadas exitosamente en{" "}
          <strong>{config ? config.label : entidad}</strong>.
        </div>
      )}

    </div>
  );
};

export default ResultadoCarga;
